var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scan_inner" },
    [
      _vm.value.config.imageurl
        ? _c("el-image", { attrs: { src: _vm.value.config.imageurl } })
        : _c("div", { staticClass: "image-slot" }, [
            _c("i", { staticClass: "el-icon-picture" }),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }